(function () {
    'use strict';

    angular.module('gallery')
        .service('GalleryConfigService', GalleryConfigService);

    GalleryConfigService.$inject = ['serviceBase'];
    function GalleryConfigService(serviceBase) {
        return {
            deleteImageURL: serviceBase + '/road-monitoring/image/remove/',
            getImageListURL: serviceBase + '/road-monitoring/image/list/',
            getImageURL: serviceBase + '/road-monitoring/image/',
            postImageURL: serviceBase + '/road-monitoring/image/'
        };
    }
})();
